<template>
    <v-container fluid fill-height class="data-not-found-page">
        <v-layout align-center justify-center>
            <v-card flat class="pa-8 text-center data-not-found-card">
                <v-img
                    src="/static/error/404.svg"
                    contain
                    height="220"
                    class="mb-6"
                ></v-img>
                <h1 class="display-1 font-weight-bold mb-3">
                    Dữ liệu không tồn tại
                </h1>
                <p class="subtitle-1 grey--text text--darken-1 mb-7">
                    Dữ liệu bạn yêu cầu không tồn tại hoặc bạn không có quyền truy cập.
                </p>
                <v-btn outlined color="primary" class="mr-3" @click="goBack">
                    <v-icon left>fa-arrow-left</v-icon>
                    Quay lại
                </v-btn>
                <v-btn color="primary" @click="goHome">
                    <v-icon left>fa-home</v-icon>
                    Về trang chủ
                </v-btn>
            </v-card>
        </v-layout>
    </v-container>
</template>

<script>
export default {
    name: 'DataNotFound',

    methods: {
        goBack() {
            if (window.history.length > 1) {
                this.$router.go(-1)
                return
            }
            this.goHome()
        },
        goHome() {
            this.$router.push({ name: 'Dashboard' })
        }
    }
}
</script>

<style scoped>
.data-not-found-page {
    min-height: 60vh;
}

.data-not-found-card {
    max-width: 620px;
    width: 100%;
}
</style>
